module.exports = __webpack_public_path__ + "img/4.a2d0b71c.png";